export enum ReportingEventType {
  Registrations = 1,
  Login = 2,
  SupportRequestPhone = 3,
  SupportRequestLiveChat = 4,
  SupportRequestVideoCall = 5,
  SupportRequestRequestCallback = 6,
  MiniHealthCheck = 7,
  Trackers = 8,
  FourWeekPlans = 9,
  Preferences = 10,
  MoodTracker = 11,
  SupportWhatsApp = 17,
  StudentHubOpened = 24,
  SupportMomentOpened = 25,
  SupportMomentCompleted = 26,
  SupportMomentBranchSelected = 27,
  SupportMomentOutcomeCheckIn = 28,
  SupportMomentResourceUsed = 29,
  SupportMomentFirstUse = 30,
}
